import PropTypes from 'prop-types'

import { Box, Chip, Tooltip, Typography } from '@material-ui/core'

const IMPORT_STATUS_LABELS = {
  completed: 'Concluído',
  processing: 'Processando',
  pending: 'Pendente',
  failed: 'Falhou',
}

const IMPORT_STATUS_COLORS = {
  completed: 'primary',
  processing: 'default',
  pending: 'default',
  failed: 'secondary',
}

const ImportTooltipContent = ({ importData }) => (
  <Box display="flex" flexDirection="column" gridGap={4}>
    <Typography variant="caption">
      Progresso: {importData.progress ?? 0}%
    </Typography>
    <Typography variant="caption">
      Atividades: {importData.totalActivities ?? 0}
    </Typography>
    <Typography variant="caption">
      Evidências: {importData.processedEvidencesCount ?? 0}/
      {importData.totalActivities ?? 0} (falhas:{' '}
      {importData.failedEvidencesCount ?? 0})
    </Typography>
    <Typography variant="caption">
      Etapas: {importData.processedStagesCount ?? 0}/
      {importData.totalActivities ?? 0} (falhas:{' '}
      {importData.failedStagesCount ?? 0})
    </Typography>
    {importData.errorMessage && (
      <Typography variant="caption">{importData.errorMessage}</Typography>
    )}
  </Box>
)

const ImportInfo = ({ importData }) => {
  if (!importData) return <Typography variant="body2">-</Typography>

  const label = IMPORT_STATUS_LABELS[importData.status] || importData.status
  const color = IMPORT_STATUS_COLORS[importData.status] || 'default'

  return (
    <Tooltip title={<ImportTooltipContent importData={importData} />}>
      <Chip size="small" label={label} color={color} />
    </Tooltip>
  )
}

ImportInfo.propTypes = {
  importData: PropTypes.object,
}

export default ImportInfo
